import UserLinkRenderer from "./UserLinkRenderer";
import CheckboxRenderer from "components/common/ag-grid/CheckboxRenderer";

export const columnDefs = [
  { 
    headerName: 'ID#',
    field: 'user_code',
    minWidth: 110,
    cellRenderer: UserLinkRenderer
  },
  { 
    headerName: 'Name',
    field: 'name',
    minWidth: 90,
    width: 100,
    flex: 0,
    pinned: 'left',
    cellRenderer: UserLinkRenderer
  },
  { 
    headerName: 'Full of name',
    field: 'full_name',
    minWidth: 200
  },
  { 
    headerName: 'Email',
    field: 'email',
    minWidth: 200
  },
  { 
    headerName: 'Active',
    field: 'active',
    minWidth: 100,
    cellRenderer: CheckboxRenderer
  },
  { 
    headerName: 'Admin meeting room',
    field: 'admin_meeting_room',
    minWidth: 100,
    cellRenderer: CheckboxRenderer
  },

  { 
    headerName: 'Sales unit',
    field: 'sales_unit.description',
    minWidth: 200
  },
  { 
    headerName: 'Site',
    field: 'site.name',
    minWidth: 180
  },
  { 
    headerName: 'Signed in IP Address',
    field: 'current_sign_in_ip',
    minWidth: 140
  },
  { 
    headerName: 'Updated date',
    field: 'updated_at',
    minWidth: 200
  },
  { 
    headerName: 'Created date',
    field: 'created_at',
    minWidth: 200
  },
];